__webpack_require__.p = "https://dms-report.dev.mkit.vn/";